(function () {
  'use strict';
  const cart = document.getElementById('tf-cart-modal');
  const button = document.getElementById('tf-cart-return-toggle');
  const note = document.getElementById('tf-cart-return-note');
  if (!cart || !button || !note) return;
  const row = button.closest('.tf-cart-return-policy');
  function hide() {
    note.hidden = true;
    button.setAttribute('aria-expanded', 'false');
  }
  button.addEventListener('click', function () {
    note.hidden = !note.hidden;
    button.setAttribute('aria-expanded', String(!note.hidden));
  });
  document.addEventListener('click', function (event) {
    if (!note.hidden && !row.contains(event.target)) hide();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !note.hidden) {
      event.preventDefault();
      event.stopPropagation();
      hide();
      button.focus({ preventScroll: true });
    }
  }, true);
  cart.addEventListener('close', hide);
})();
